import React, { useCallback } from 'react';
import { SearchResultsLayout } from '../Common/SearchResultsLayout/SearchResultsLayout';
import { useSelector } from 'react-redux';
import {
  extractNonHistoricalTicketIdFromState,
  getSimplrAccountIdOfSelectedTicket,
  getBrandOfSelectedTicket,
} from '../../../../../../../extractFromState';
import { fetchCommonOrder } from '../../../../../../../actions/tools/CommonAsyncOrderActions';

const SearchResultsCommon = () => {
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const conversationId = useSelector(extractNonHistoricalTicketIdFromState);
  const brand = useSelector(getBrandOfSelectedTicket);

  const handleSelectOrder = useCallback(
    (order) => {
      return fetchCommonOrder(String(simplrAccountId), order, conversationId, brand);
    },
    [simplrAccountId, conversationId, brand]
  );

  return <SearchResultsLayout onSelectOrder={handleSelectOrder} />;
};

export default SearchResultsCommon;
